import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, SearchIcon, BadgeDollarSignIcon } from 'lucide-react';
const cards = [{
  icon: UsersIcon,
  title: 'Bill Auditors',
  subtitle: 'TELECOM EXPENSE SPECIALISTS',
  description: 'We analyze every line item on your telecom bills to uncover hidden fees, billing errors, and overcharges that cost your business thousands each year.',
  bg: 'bg-slate-100'
}, {
  icon: SearchIcon,
  title: 'Rate Negotiators',
  subtitle: 'EXCLUSIVE PROVIDER ACCESS',
  description: "We leverage relationships with every major carrier to negotiate rates your business can't get on its own. We guarantee the most competitive pricing available.",
  bg: 'bg-blue-200/60'
}, {
  icon: BadgeDollarSignIcon,
  title: 'Cost Optimizers',
  subtitle: 'ONGOING EXPENSE REDUCTION',
  description: "We don't just find savings once — we continuously monitor your telecom spend, flag cost creep, and recommend adjustments to keep your expenses as low as possible.",
  bg: 'bg-blue-300/50'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhatMakesUsDifferent() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-337">
      {/* Subtle dot pattern background */}
      <div className="absolute inset-0 opacity-[0.08]" style={{
      backgroundImage: 'radial-gradient(circle, #94a3b8 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-338" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-339">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 text-center mb-16" data-id="element-340">
          How We Cut Your Telecom Costs
        </h2>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-341">
          {cards.map((card, i) => {
          const Icon = card.icon;
          return <motion.div key={i} variants={cardVariants} className={`${card.bg} rounded-2xl p-8 md:p-10 flex flex-col min-h-[320px]`} data-id="element-342">
                <div className="w-12 h-12 bg-slate-700 rounded-full flex items-center justify-center mb-6" data-id="element-343">
                  <Icon className="w-5 h-5 text-slate-300" data-id="element-344" />
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-1" data-id="element-345">
                  {card.title}
                </h3>
                <p className="text-sm font-bold text-slate-800 uppercase tracking-wide mb-4" data-id="element-346">
                  {card.subtitle}
                </p>
                <p className="text-slate-600 leading-relaxed" data-id="element-347">
                  {card.description}
                </p>
              </motion.div>;
        })}
        </motion.div>

        <div className="flex justify-center mt-12" data-id="element-348">
          <a href="#services" className="bg-slate-900 hover:bg-slate-800 text-white px-10 py-4 rounded-full font-semibold text-lg transition-colors" data-id="element-349">
            See how much you can save
          </a>
        </div>
      </div>
    </section>;
}